<template>
  <div class="privacy-page">
    
        <div style="width: 100%; height: 65px; position: fixed; background-color: black;"></div>
    <div class="container">
      <h1 class="title">中青网隐私政策</h1>
      <!-- <p class="subtitle">生效日期：2025-11-04（最近更新）</p> -->

      <div class="card">
        <p>中青网非常重视您的个人信息与隐私保护。本《隐私政策》将说明我们如何收集、使用、存储、共享和保护您的个人信息，以及您所享有的权利。请您在使用中青网服务前仔细阅读并充分理解本政策内容。</p>
        <p>当您使用或继续使用我们的产品/服务，即表示您同意本《隐私政策》的全部内容。</p>
      </div>

      <div class="section">
        <h2>一、适用范围</h2>
        <p>本政策适用于您通过中青网网站及后续可能提供的其他形态（包括但不限于 H5/移动端）使用的服务（以下统称“本服务”）。如我们提供的特定服务另有独立的隐私说明，以该说明为准；未尽事项，适用本政策。</p>
      </div>

      <div class="section">
        <h2>二、我们如何收集与使用您的个人信息</h2>
        <p>我们仅为实现业务功能、改善用户体验与履行法定义务之目的收集并使用必要信息：</p>
        <ol>
          <li><strong>注册与登录：</strong>手机号/邮箱、用户名、密码、头像（可选）。用于创建账户、身份验证与安全登录。</li>
          <li><strong>内容与交易：</strong>购买/解锁记录、订单信息、支付时间与金额（不保存完整支付敏感信息）、虚拟币（硬币）余额与变动，用于展示订单、售后与合规对账。</li>
          <li><strong>创作与互动：</strong>您上传的音乐/漫画/评论/点赞/收藏等内容与行为数据，用于内容展示、社区秩序与反垃圾处理。</li>
          <li><strong>设备与日志：</strong>设备型号、操作系统、浏览器类型、IP地址、网络环境、访问时间与页面轨迹等日志信息，用于安全风控、问题排查与服务优化。</li>
          <li><strong>定位（可选）：</strong>如需基于位置推荐或活动服务，将在取得授权后收集大致位置信息，可在系统设置中随时关闭。</li>
        </ol>
        <p>我们不会以任何方式强制收集与业务无关的信息。若需超出上述目的使用您的信息，我们将再次征得您的同意。</p>
      </div>

      <div class="section">
        <h2>三、Cookie 与同类技术</h2>
        <p>为提供更便捷的访问体验与个性化服务，我们可能使用 Cookie、LocalStorage 或同类技术记住您的偏好设置、登录状态与会话信息。您可在浏览器设置中清除或限制相关技术，但可能影响部分功能使用。</p>
      </div>

      <div class="section">
        <h2>四、第三方服务与共享</h2>
        <ol>
          <li><strong>支付服务：</strong>与支付机构仅在必要范围内共享订单号、金额、时间等信息以完成交易；我们不保存完整的银行卡号、安全码等敏感支付数据。</li>
          <li><strong>内容存储与分发：</strong>图片/音频/视频可能由第三方云存储或 CDN 加速分发；我们仅在必要范围内共享用于提供服务的资源链接与最小化信息。</li>
          <li><strong>统计与反作弊：</strong>为改进产品与保障安全，可能集成统计或风控组件，仅收集必要的设备与行为特征信息。</li>
        </ol>
        <p><strong>我们不会向任何无关第三方出售您的个人信息。</strong>除非：（1）事先获得您的授权同意；（2）法律法规、司法或行政机关依法要求；（3）为保护您、我们或公众利益、财产或安全所必要；（4）为实现本政策所述目的之必要且采取了安全保护措施。</p>
      </div>

      <div class="section">
        <h2>五、未成年人保护</h2>
        <p>我们高度重视未成年人信息保护。若您为未成年人，请在监护人监护、指导下使用本服务；如您是监护人，请关注未成年人使用情况并指导其正确理解本政策。我们将尽力减少对未成年人的不必要信息收集与处理。</p>
      </div>

      <div class="section">
        <h2>六、您的权利</h2>
        <p>在法律法规允许范围内，您可通过产品内设置或联系客服行使以下权利：</p>
        <ol>
          <li><strong>访问与复制：</strong>查询或获取您的账户基本信息、订单与余额等记录。</li>
          <li><strong>更正与补充：</strong>更新不准确或不完整的信息（如昵称、头像、联系方式等）。</li>
          <li><strong>删除：</strong>在符合法定条件或无需继续处理时，您可申请删除相关个人信息。</li>
          <li><strong>撤回同意：</strong>对于基于同意的处理，您可随时撤回，但可能影响相关功能的正常使用。</li>
          <li><strong>账户注销：</strong>您可通过流程申请注销账户。我们将在符合法律要求的期限内处理，并根据合规要求保留必要记录。</li>
        </ol>
      </div>

      <div class="section">
        <h2>七、信息的存储与保护</h2>
        <ol>
          <li>我们采取合理且必要的安全技术与管理措施（如加密、访问控制、最小化授权、日志审计等）保护您的信息安全，防止泄露、篡改、丢失与滥用。</li>
          <li>除法律法规另有规定外，我们仅在实现本政策所述目的所必需的最短期限内保存您的个人信息。不同场景可能适用不同法定或业务保存期限。</li>
          <li>尽管我们采取了合理安全措施，仍无法保证数据在所有情况下绝对安全。若不幸发生安全事件，我们将按法规要求告知您并采取补救措施。</li>
        </ol>
      </div>

      <div class="section">
        <h2>八、跨境传输（如适用）</h2>
        <p>如在特定业务中涉及跨境数据传输，我们将依据相关法律法规履行评估、备案、合同保障等合规要求，并告知您相关情况。</p>
      </div>

      <div class="section">
        <h2>九、本政策的更新</h2>
        <p>我们可能会根据业务、技术与法律变化对本政策进行更新。<strong>如涉及重要变更（例如处理目的、处理方式、处理的个人信息类型等发生实质性变化），我们将以站内公告或弹窗等方式提示。</strong>若您不同意变更内容，请停止使用本服务；如您继续使用，即视为同意更新后的政策。</p>
      </div>

      <div class="section">
        <h2>十、联系我们</h2>
        <p>如对本政策或您的个人信息相关事宜有任何疑问、建议或投诉，请通过以下方式联系：</p>
        <ul>
          <li>客服邮箱：zqwzbs@126.com</li>
          <li>工作时间：每日 9:00-22:00（法定节假日照常）</li>
          <li>我们将尽力在合理时限内进行核查与答复。</li>
        </ul>
      </div>

      <div class="card foot">
        <p>提示：继续使用中青网，即表示您已阅读并同意本《隐私政策》。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
}
</script>

<style scoped lang="scss">
.privacy-page { background:#fff; color:#0f172a; }
.container { max-width: 900px; margin: 0 auto; padding: 92px 16px 60px; }
.title { margin:0; font-size: 32px; font-weight: 800; letter-spacing: -.3px; }
.subtitle { margin: 6px 0 16px; color:#64748b; }

.card { background:#fff; border:1px solid #e2e8f0; border-radius: 12px; padding: 14px; margin-bottom: 14px; }
.card.foot { background:#f8fafc; }

.section { background:#fff; border:1px solid #e2e8f0; border-radius: 12px; padding: 14px; margin-bottom: 14px; }
.section h2 { margin:0 0 10px; font-size: 16px; font-weight: 800; color:#0f172a; }
.section p { margin: 8px 0; color:#334155; line-height: 1.75; }
.section ol, .section ul { margin: 8px 0 0 18px; color:#334155; line-height: 1.75; }
.section li { padding-left: 4px; }

@media (max-width: 520px) {
  .container { padding: 88px 12px 40px; }
  .title { font-size: 24px; }
}
</style>
